module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//5.jpg?239b514424b424ccac7eae7df3e51b56";